/** Sozlamalar va Profil (K3), Brief 12. */
import type { uzB12Settings } from "./uz-b12-settings";

export const ruB12Settings: Record<keyof typeof uzB12Settings, string> = {
  "soz.title": "Настройки",
  "soz.navLabel": "Разделы настроек",
  "soz.section": "Раздел",
  "soz.sectionLabel": "Раздел настроек",
  "soz.group.agency": "Агентство",
  "soz.group.distribution": "Распределение",
  "soz.group.ai": "ИИ",
  "soz.group.finance": "Финансы",
  "soz.group.audit": "Аудит",
  "soz.nav.agency": "Данные агентства",
  "soz.nav.billing": "Тариф и оплата",
  "soz.nav.funnel": "Воронка",
  "soz.nav.team": "Команда и филиалы",
  "soz.nav.distribution": "Правила распределения",
  "soz.nav.channels": "Каналы",
  "soz.nav.operators": "Туроператоры и провайдеры",
  "soz.nav.catalog": "Сопоставление каталога",
  "soz.nav.pricing": "Цены и наценки",
  "soz.nav.ai": "Настройки ИИ",
  "soz.nav.documents": "Требования к документам",
  "soz.nav.templates": "Шаблоны",
  "soz.nav.finance": "Кассы и платёжные системы",
  "soz.nav.sla": "SLA и напоминания",
  "soz.nav.notifications": "Уведомления",
  "soz.nav.import": "Импорт",
  "soz.nav.audit": "Журнал аудита",
  "soz.nav.system": "Состояние системы",
  "soz.save": "Сохранить",
  "soz.saved": "Сохранено",
  "soz.saveFailed": "Не удалось сохранить. Попробуйте ещё раз.",
  "soz.loadFailed": "Не удалось загрузить настройки.",
  "soz.upload": "Загрузить",
  "soz.add": "Добавить",
  "soz.edit": "Изменить",
  "soz.agency.name": "Название",
  "soz.agency.nameHint": "Видно клиентам",
  "soz.agency.legal": "Юридическое название",
  "soz.agency.legalHint": "В договоре и счёт-фактуре",
  "soz.agency.inn": "ИНН",
  "soz.agency.phone": "Телефон",
  "soz.agency.address": "Адрес",
  "soz.agency.rate": "Курс валюты",
  "soz.agency.rateHint": "Используется в финансах и ценах",
  "soz.agency.rateSource": "Центральный банк Узбекистана (CBU)",
  "soz.agency.rateToday": "Сегодня 1 $ = {amount}",
  "soz.agency.rateMissing": "Сегодняшний курс ещё не получен",
  "soz.agency.saved": "Данные агентства сохранены",
  "soz.funnel.subtitle": "Стадии сделки и причины потери",
  "soz.team.subtitle": "Текущий статус сотрудников, расписание и отпуска.",
  "soz.team.people": "Сотрудники",
  "soz.team.person": "Сотрудник",
  "soz.team.add": "Добавить сотрудника",
  "soz.team.onLeave": "В отпуске",
  "soz.team.branchCount": "Сотрудников: {people}",
  "soz.team.branchClients": "клиентов: {count}",
  "soz.team.emptyHint": "Пригласите первого сотрудника.",
  "soz.dist.subtitle": "Определяет, кому попадёт новое обращение. Правила проверяются сверху вниз.",
  "soz.dist.rule": "Распределять только операторам в статусе «На работе»",
  "soz.dist.ruleHint": "Статус каждый сотрудник выбирает сам в меню аватара. Со статусом «Перерыв» и «Не на работе» новые обращения не приходят, клиенты отпускников переходят к заместителю.",
  "soz.dist.next": "Сейчас получают обращения: {names}. Следующий: {next}.",
  "soz.dist.nobody": "Сейчас никто не на работе. Обращения попадут менеджеру.",
  "soz.dist.returning": "Вернувшийся клиент",
  "soz.channels.subtitle": "Аккаунты Telegram и страница Instagram, куда пишут клиенты",
  "soz.ops.subtitle": "Брони, цены и сообщения операторов приходят через эти подключения.",
  "soz.ops.lastSync": "Посл. синхр.",
  "soz.ops.login": "Логин",
  "soz.ops.count": "{count} шт.",
  "soz.pricing.subtitle": "Наценка рассчитывает цену брутто. Всё, что уходит клиенту, показывает только брутто.",
  "soz.pricing.watch": "Отслеживание цен",
  "soz.finance.subtitle": "Кассы раздела финансов и онлайн-ссылки на оплату",
  "soz.finance.gateways": "Платёжные системы",
  "soz.finance.gatewaysHint": "Ссылки Payme и Click создаются с этими данными",
  "soz.finance.categories": "Категории расходов",
  "soz.finance.categoriesHint": "Отключённая категория уходит в архив. Расходы в истории сохраняются",
  "soz.finance.categoryNew": "Новая категория",
  "soz.finance.rules": "Валюта и ссылки",
  "soz.sla.subtitle": "Сроки первого ответа и эскалации",
  "soz.sla.deadlines": "Сроки ответа",
  "soz.sla.deadlinesHint": "В тихие часы SLA не считается",
  "soz.sla.first": "Первый ответ",
  "soz.sla.manager": "Сообщение менеджеру",
  "soz.sla.quiet": "Тихие часы",
  "soz.sla.min": "мин",
  "soz.sla.always": "Нет, 24 часа",
  "soz.sla.saved": "SLA сохранён",
  "soz.sla.noBranches": "Филиалов нет.",
  "soz.sla.reminders": "Автоматические напоминания",
  "soz.notif.subtitle": "Правила уровня агентства. Каждый сотрудник дополнительно настраивает их в профиле",
  "soz.notif.who": "Кому что приходит",
  "soz.notif.own": "Настроить свои уведомления",
  "soz.system.subtitle": "Каналы, туроператоры, ИИ и платёжные системы",
  "soz.system.integrations": "Интеграции",
  "soz.system.check": "Проверить сейчас",
  "soz.system.keys": "Ключи",
  "soz.system.aiLimits": "Ограничения ИИ",
  "soz.system.tours": "Поиск туров и предложения",
  "soz.tpl.subtitle": "Документы и быстрые ответы в чате",
  "soz.tpl.replies": "Быстрые ответы",
  "soz.tpl.repliesHint": "Вызываются в чате через «/»",
  "soz.tpl.addReply": "Добавить ответ",
  "soz.tpl.editReply": "Изменить ответ",
  "soz.tpl.command": "Команда",
  "soz.tpl.text": "Текст",
  "soz.tpl.noReplies": "Быстрых ответов пока нет.",
  "soz.denied": "Настройки доступны владельцу и менеджеру агентства.",
  "settings.cap.view_sales_reports": "Просмотр отчётов о продажах",
  "settings.cap.view_custdev": "Просмотр отчёта CustDev",
  "settings.cap.see_passport": "Полный просмотр паспорта",
  "settings.cap.manage_destinations": "Настройка направлений",
  "settings.cap.use_inbox": "Работа в чатах",
  "soz.ops.cap.search": "Поиск",
  "soz.ops.cap.claims": "Брони",
  "soz.ops.cap.hotels": "Отели",
  "soz.ops.cap.rates": "Курсы",
  "soz.ops.cap.reference": "Справочники",
  "soz.ops.cap.points": "Места",
  "soz.agency.language": "Язык",
  "soz.team.duty": "Дежурства",
  "soz.team.access": "Доступ к чатам",
  "soz.ops.capabilities": "Возможности",
  "soz.finance.notConnected": "Не подключено",
  "soz.finance.gatewayWait": "Данные мерчанта подключает команда Kapitan. После подключения статус появится здесь.",
  "settings.cash.branchCol": "Филиал",
  "soz.sla.hours": "Рабочее время",
  "soz.sla.opens": "Открытие",
  "soz.sla.closes": "Закрытие",
  "prof.navHint": "Настройки профиля",
  "prof.navLabel": "Разделы профиля",
  "prof.photo": "Фото",
  "prof.photoHint": "JPG или PNG, больше 400×400",
  "prof.nameAndContact": "Имя и контакты",
  "prof.firstName": "Имя",
  "prof.lastName": "Фамилия",
  "prof.workplace": "Место работы",
  "prof.workplaceHint": "меняет только владелец",
  "prof.schedule.subtitle": "Статус влияет на распределение обращений.",
  "prof.schedule.now": "Текущий статус",
  "prof.schedule.nowHint": "В статусе «На работе» новые обращения идут вам",
  "prof.schedule.days": "Рабочие дни",
  "prof.schedule.hours": "Рабочее время",
  "prof.schedule.from": "с",
  "prof.schedule.to": "до",
  "prof.schedule.leave": "Отпуск или болезнь",
  "prof.schedule.leaveHint": "вступает в силу после подтверждения менеджером",
  "prof.look.darkRail": "Тёмная боковая панель",
  "prof.look.darkRailHint": "Только на этом устройстве",
  "prof.look.langHint": "Сообщения туроператоров остаются на языке оригинала",
  "prof.look.moneyTitle": "Показ сумм",
  "prof.look.moneyHint": "В списках и карточках",
  "prof.notif.subtitle": "Выберите, какое событие в какой канал приходит.",
  "prof.notif.event": "Событие",
  "prof.notif.quiet": "Тихий режим",
  "prof.notif.quietHint": "Только в системе, без звука и push",
  "prof.signature.hint": "Добавляется и к текстам ИИ",
  "prof.signature.text": "Текст подписи",
  "prof.security.password": "Пароль",
  "prof.security.passwordChange": "Сменить пароль",
  "prof.security.twoFactorHint": "При входе код приходит в Telegram",
  "prof.security.devices": "Активные устройства",
  "prof.security.telegram": "Telegram-бот",
  "prof.deny.title": "Нет доступа",
  "soz.billing.title": "Тариф и оплата",
  "soz.billing.subtitle": "Подписка Kapitan, лимиты и движения по счёту",
  "soz.billing.current": "Текущий тариф",
  "soz.billing.nextPayment": "Следующая оплата {date}",
  "soz.billing.change": "Изменить тариф",
  "soz.billing.buy": "Купить кредиты",
  "soz.billing.tariff": "Тариф",
  "soz.billing.noTariff": "Тариф не назначен",
  "soz.billing.perMonth": "{name} · {price} в месяц",
  "soz.billing.members": "Пользователи",
  "soz.billing.branches": "Филиалы",
  "soz.billing.credits": "AI-кредиты",
  "soz.billing.creditsSplit": "пакет {package} · куплено {purchased}",
  "soz.billing.expiring": "{count} истекут в течение 7 дней",
  "soz.billing.lasts": "хватит на ~{days} дн.",
  "soz.billing.balance": "Баланс",
  "soz.billing.method": "Способ оплаты",
  "soz.billing.methodBank": "Банковский перевод",
  "soz.billing.ledger": "Движение баланса",
  "soz.billing.ledgerHint": "Здесь остаётся каждое пополнение и списание",
  "soz.billing.ledgerEmpty": "Движений пока нет.",
  "soz.billing.date": "Дата",
  "soz.billing.description": "Описание",
  "soz.billing.amount": "Сумма",
  "soz.billing.status": "Статус",
  "soz.billing.requests": "Заявки на кредиты",
  "soz.billing.requestsHint": "Кредиты начисляются после подтверждения оплаты платформой",
  "soz.billing.requestsFailed": "Не удалось загрузить заявки.",
  "soz.billing.creditCount": "Кредиты",
  "soz.billing.usage": "История расхода",
  "soz.billing.at": "Время",
  "soz.billing.note": "Комментарий",
  "soz.billing.ownerOnly": "Нет прав на просмотр этого раздела.",
  "soz.billing.sent": "Заявка отправлена. Кредиты начислятся после подтверждения оплаты.",
  "soz.billing.sendFailed": "Не удалось отправить заявку.",
  "soz.billing.creditsField": "Количество кредитов (1 — {max})",
  "soz.billing.priceNote": "Цена берётся из тарифа. Оплата банковским переводом; до подтверждения ничего не списывается.",
  "soz.billing.noteField": "Комментарий (необязательно)",
  "soz.billing.send": "Отправить заявку",
  "soz.import.title": "Импорт",
  "soz.import.subtitle": "Перенос клиентов из Excel или Google Sheets",
  "soz.import.new": "Новый импорт",
  "soz.import.newHint": "XLSX или CSV · столбцы сопоставите на следующем шаге",
  "soz.import.choose": "Выбрать файл",
  "soz.import.sample": "Файл-образец",
  "soz.import.fileLabel": "Файл импорта",
  "soz.import.note": "Клиенты с тем же телефоном повторно не добавляются. Импорт можно отменить в течение 24 часов.",
  "soz.import.history": "История импорта",
  "soz.import.historyEmpty": "Импортов пока не было.",
  "soz.import.file": "Файл",
  "soz.import.rows": "Строки",
  "soz.import.who": "Кто",
  "soz.import.rowsDone": "{count}",
  "soz.import.rowsErrors": "{count} · ошибок: {failed}",
  "soz.import.uploadFailed": "Не удалось загрузить файл.",
  "soz.import.batchFailed": "Не удалось загрузить партию.",
  "soz.import.rowCount": "строк: {count}",
  "soz.import.other": "Другой файл",
  "soz.import.step1": "1. Сопоставьте столбцы",
  "soz.import.required": "{label} (обязательно)",
  "soz.import.noColumn": "— нет столбца",
  "soz.import.missing": "Не выбраны обязательные столбцы: {fields}",
  "soz.import.allChosen": "Обязательные столбцы выбраны.",
  "soz.import.mapSaved": "Сопоставление сохранено.",
  "soz.import.mapFailed": "Не удалось сохранить сопоставление.",
  "soz.import.committed": "Клиенты импортированы.",
  "soz.import.commitFailed": "Не удалось завершить импорт.",
  "soz.import.mapFirst": "Сначала сопоставьте обязательные столбцы: предпросмотр появится здесь.",
  "soz.import.step2": "2. Предпросмотр",
  "soz.import.willImport": "Будет импортировано: {count}",
  "soz.import.willSkip": "пропущено: {count}",
  "soz.import.noRows": "Строк нет.",
  "soz.import.row": "Строка",
  "soz.import.name": "Имя",
  "soz.import.phone": "Телефон",
  "soz.import.duplicate": "Уже есть, пропускается",
  "soz.import.willBe": "Будет импортирован",
  "soz.import.commit": "Импортировать",
  "soz.import.reverted": "Импорт отменён.",
  "soz.import.revertFailed": "Не удалось отменить.",
  "soz.import.step3": "3. Отчёт",
  "soz.import.statImported": "Импортировано",
  "soz.import.statFailed": "Пропущено с ошибкой",
  "soz.import.statTotal": "Всего строк",
  "soz.import.errors": "Скачать ошибки",
  "soz.import.errorsFailed": "Не удалось скачать файл ошибок.",
  "soz.import.revert": "Отменить импорт",
  "soz.import.revertedNote": "Этот импорт отменён. Клиенты, с которыми вы работали, сохранены.",
  "soz.audit.subtitle": "Кто, когда и что сделал. Записи нельзя удалить",
  "soz.audit.recent": "Последние действия",
  "soz.audit.csv": "Экспорт CSV",
  "soz.audit.csvFailed": "Не удалось скачать файл.",
  "soz.audit.filters": "Фильтры",
  "soz.audit.chip.passport": "Просмотр паспорта",
  "soz.audit.chip.storno": "Сторно платежа",
  "soz.audit.chip.ai": "Настройка AI",
  "soz.audit.chip.login": "Вход",
  "soz.audit.staff": "Сотрудник",
  "soz.audit.action": "Действие",
  "soz.audit.severityInfo": "Информация",
  "soz.audit.severityWarning": "Предупреждение",
  "soz.audit.severityCritical": "Важно",
  "soz.audit.kind.user": "Пользователь",
  "soz.audit.kind.ai": "AI-агент",
  "soz.audit.kind.automation": "Автоматизация",
  "soz.audit.kind.system": "Система",
  "soz.audit.kind.platform_admin": "Администратор платформы",
  "soz.audit.kind.client": "Клиент",
  "soz.audit.kind.gateway": "Платёжная система",
  "soz.audit.label.auth.login": "Вход в систему",
  "soz.audit.label.auth.login_failed": "Вход отклонён",
  "soz.audit.label.traveler.passport_viewed": "Просмотрен паспорт",
  "soz.audit.label.payment.storno": "Сторно платежа",
  "soz.audit.label.payment.approved": "Платёж подтверждён",
  "soz.audit.label.settings.changed": "Настройка изменена",
  "soz.audit.label.export.created": "Экспорт скачан",
  "soz.funnel.stages": "Этапы",
  "soz.funnel.stagesHint": "Системные этапы связаны с отчётами и автоматизацией",
  "soz.funnel.system": "{name} · система",
  "soz.funnel.earlier": "Сдвинуть {name} раньше",
  "soz.funnel.later": "Сдвинуть {name} позже",
  "soz.funnel.reasons": "Причины потери",
  "soz.funnel.reasonsHint": "Выбирается при переводе сделки в потерянные",
  "soz.funnel.reasonsEmpty": "Причины ещё не добавлены.",
  "soz.funnel.cold": "Остывшая сделка",
  "soz.finance.cashHint": "Выключенная касса уходит в архив. Платежи в истории сохраняются",
  "soz.finance.cash": "Касса",
  "soz.finance.kind": "Тип",
  "soz.finance.allBranches": "Все",
  "soz.channels.telegramHint": "Каждый аккаунт привязан к филиалу",
  "soz.channels.connect": "Подключить Telegram",
  "soz.channels.account": "Аккаунт",
  "soz.channels.branch": "Филиал",
  "soz.channels.state": "Статус",
  "soz.channels.note": "Комментарий",
  "soz.channels.lastMessage": "последнее сообщение {when}",
  "soz.channels.noMessage": "сообщений ещё нет",
  "soz.channels.actions": "{name}: действия",
  "soz.channels.reconnect": "Переподключить",
  "soz.channels.settings": "Настройки",
  "soz.channels.disconnect": "Отключить",
  "soz.channels.settingsTitle": "{name}: настройки",
  "soz.channels.loadFailed": "Не удалось загрузить список аккаунтов.",
  "soz.channels.none": "Telegram-аккаунт ещё не подключён.",
  "soz.channels.historyFailed": "История не импортирована",
  "soz.channels.instagramHint": "Direct и комментарии",
  "igSet.network": "Нет связи с сервером. Попробуйте ещё раз.",
  "igSet.callbackFailed": "Instagram не подключён. Попробуйте ещё раз.",
  "igSet.ownerOnly": "Подключением Instagram управляет только владелец.",
  "igSet.connected": "Instagram подключён.",
  "igSet.working": "Подключение работает.",
  "igSet.disconnected": "Instagram отключён.",
  "igSet.loadFailed": "Не удалось загрузить состояние Instagram.",
  "igSet.retry": "Повторить",
  "igSet.connect": "Подключить",
  "igSet.confirmTitle": "Отключить Instagram?",
  "igSet.cancel": "Отмена",
  "igSet.disconnect": "Отключить",
  "igSet.confirmBody": "Direct и комментарии {account} перестанут приходить в Kapitan. AI на этом канале остановится.",
  "igSet.thisAccount": "этого аккаунта",
  "igSet.connectedAt": "Дата подключения",
  "igSet.tokenExpires": "Срок токена",
  "igSet.lastSuccess": "Последняя успешная проверка",
  "igSet.webhook": "Webhook",
  "igSet.webhookOn": "Активен",
  "igSet.webhookOff": "Неактивен",
  "igSet.test": "Проверить подключение",
  "igSet.phase.notConfigured": "Не настроен",
  "igSet.phase.notConnected": "Не подключён",
  "igSet.phase.stateConnected": "Подключён",
  "igSet.phase.expiring": "Токен скоро истекает",
  "igSet.phase.fallback": "Не настроен — Платформа → Интеграции → Meta",
  "igSet.phase.error": "Ошибка",
  "soz.channels.status": "Статус",
  "soz.channels.excluded": "Исключённые чаты",
  "soz.channels.telegram": "Telegram-аккаунты",
  "soz.finance.addCash": "Добавить кассу",
  "soz.funnel.addStage": "Добавить этап",
  "prof.security.more": "Ещё устройств: {count}",
  "soz.error.title": "Настройки не загрузились",
  "soz.error.message": "Сервер не ответил. Введённые данные сохранены, страницу можно безопасно перезагрузить.",
  "soz.loading": "Получаем данные…",
  "soz.error.code": "Ошибка {status} · {when}",
  "soz.channels.rules": "Правила каналов",
  "soz.system.lastCheck": "Последняя проверка: {time}",
  "soz.system.subtitleLive": "Каналы, туроператоры, AI и платёжные системы · обновляется каждые 5 минут",
  "soz.katalog.kpi.matchedHint": "Автоматически и подтверждено",
  "soz.katalog.kpi.reviewHint": "Достоверность ниже 90%",
  "soz.katalog.kpi.unmatchedNote": "Эти туры не появляются в поиске",
  "soz.katalog.more": "{name}: другие действия",
};
